import React, { useState, useEffect } from "react";
import axios from "axios";

const PendingPayments = () => {
  const [pending, setPending] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterRoom, setFilterRoom] = useState("");

  const getPendingPayments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-pending-payments`,
        {
          params: { searchName: filterName, searchRoom: filterRoom },
          withCredentials: true,
        }
      );
      setPending(res.data.pending || []);
    } catch (err) {
      console.error("Error fetching pending payments:", err);
    }
  };

  useEffect(() => {
    getPendingPayments();
  }, [filterName, filterRoom]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div>
      {/* 🔹 Filters */}
      <div className="d-flex gap-2 mb-2">
        <input
          type="text"
          placeholder="Filter by name"
          className="form-control"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Filter by room"
          className="form-control"
          value={filterRoom}
          onChange={(e) => setFilterRoom(e.target.value)}
        />
      </div>

      {/* 🔹 Table */}
      <table className="table table-bordered table-hover">
        <thead className="table-success">
          <tr>
            <th>Guest</th>
            <th>Last Paid</th>
            <th>Due On</th>
            <th>Method</th>
            <th>Room</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {pending.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No records found
              </td>
            </tr>
          ) : (
            pending.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>
                  {`$${Number(item.amount).toFixed(2)}`}{" "}
                  <br /> ON {formatDate(item.created_at)}
                </td>
                <td>{item.next_due_date}</td>
                <td className="text-capitalize">{item.method}</td>
                <td>
                  {item.bedtypename} {item.room_no} {item.property_name}
                </td>
                <td>
                  <a
                    href={`/admin/add-payment/${item.guest_id}`}
                    className="btn btn-sm btn-dark"
                  >
                    <i className="bi bi-plus-circle"></i> Add Payment
                  </a>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PendingPayments;
